import script from "./PostNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./PostNotice.vue?vue&type=script&setup=true&lang=js"

import "./PostNotice.vue?vue&type=style&index=0&id=d9fc501a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9fc501a"]])

export default __exports__